module.exports = __webpack_public_path__ + "img/748-04d492.png";